import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    userSelect: {
      link: 'b1',
      linkDefaultFashionId: 'f1',
      linkDefaultComfortId: 'c1',
      // currentQnum: 1,
      // type: null,
      type: {
        fashion: 0,
        comfort: 0,
      },

      resultId: '',
    },

    question: [
      {
        id: 'b1',
        num: 1,
        question: 'LINEで絵文字は？',
        links: [
          {
            link: 'b2',
            select: '使う',
            type: 'fashion', // fashion or comfort
          },
          {
            link: 'b2',
            select: '使わない',
            type: 'comfort', // fashion or comfort
          },
        ],
      },
      {
        id: 'b2',
        num: 2,
        question: 'どっちが幸せ？',
        links: [
          {
            link: 'b3',
            select: '我が道を行く人生',
            type: 'fashion', // fashion or comfort
          },
          {
            link: 'b3',
            select: '安定した人生',
            type: 'comfort', // fashion or comfort
          },
        ],
      },
      {
        id: 'b3',
        num: 3,
        question: '友達が落ち込んでいる時どうする？',
        links: [
          {
            link: 'fashion-comfort',
            select: '黙って肩を抱く',
            type: 'fashion', // fashion or comfort
          },
          {
            link: 'fashion-comfort',
            select: '原因を分析し、一緒に解決する',
            type: 'comfort', // fashion or comfort
          },
        ],
      },
      /*

        ファッション

       */
      {
        id: 'f1',
        num: 4,
        question: 'なるならどっち？',
        links: [
          {
            link: 'f2a',
            select: 'セブンティーンモデル',
          },
          {
            link: 'f3a',
            select: 'JK社長',
          },
        ],
      },
      {
        id: 'f2a',
        num: 5,
        question: '自分のどっちを褒めて欲しい？',
        links: [
          {
            link: 'result_f1',
            select: 'ファッション',
          },
          {
            link: 'result_f2',
            select: '変顔',
          },
        ],
      },
      {
        id: 'f3a',
        num: 5,
        question: '20年後あなたが書く本は？',
        links: [
          {
            link: 'result_f3',
            select: '「相手をころがす話し方」',
          },
          {
            link: 'result_f4',
            select: '「2100年の予言」',
          },
        ],
      },
      /*

        機能

       */
      {
        id: 'c1',
        num: 4,
        question: '明日世界が滅びるなら？',
        links: [
          {
            link: 'c2a',
            select: 'みんなにありがとうを言う',
          },
          {
            link: 'c3a',
            select: '世界を救う方法を考える',
          },
        ],
      },
      {
        id: 'c2a',
        num: 5,
        question: '両親にプレゼントするなら？',
        links: [
          {
            link: 'result_c1',
            select: '財布',
          },
          {
            link: 'result_c2',
            select: 'ハグ',
          },
        ],
      },
      {
        id: 'c3a',
        num: 5,
        question: '電車が止まった。どうする？',
        links: [
          {
            link: 'result_c3',
            select: '改札の前でじっと待つ',
          },
          {
            link: 'result_c4',
            select: '街に繰り出す',
          },
        ],
      },
    ],

    result: [
      {
        id: 'result_f1',
        title: 'ファッション好きなあなた',
        productName: 'タッセル／<br class="display--sp">キルトタッセル<br class="display--pc">ローファー',
        productBtnName: 'タッセル／キルトタッセルローファー<br>',
        productBtnLine: '2',
        text: 'センスがよくて<br class="display--sp">ファッションに手を抜かないあなたには<br class="display--sp">フェイスデザイン（足の甲の部分）で主張できる<br class="display--sp">タッセル／キルトタッセルローファーがおすすめです',
        link: 'https://store.haruta-shoes.co.jp/p/search?keyword=2022HIG05',
        imgPath: './share/images/shindan_modal_result_f1.jpg',
        name: '2022HIG05',
      },
      {
        id: 'result_f2',
        title: '個性派なあなた',
        productName: 'チェックインソールローファー<br>／おでこローファー',
        productBtnName: 'チェックインソールローファー／<br>おでこローファー',
        productBtnLine: '2',
        text: '独自の感覚を持っていて<br class="display--sp">自分のスタイルが確立しているあなたは<br class="display--sp">甲が短いチェックインソールローファーや、<br class="display--sp">つま先がぽってり丸いおでこローファーで<br class="display--sp"> さりげなく違いをアピールしましょう',
        link: 'https://store.haruta-shoes.co.jp/p/search?keyword=2022HIG07',
        imgPath: './share/images/shindan_modal_result_f2.jpg',
        name: '2022HIG07',
      },
      {
        id: 'result_f3',
        title: 'アピール上手なあなた',
        productName: 'ヒール高めの<br class="display--pc">コインローファー',
        text: '向上心に満ちていて、<br class="display--sp">話し方にも自信があふれているあなたには<br class="display--sp">目線を少しあげてさらに<br class="display--sp">みんなの注意を引きつける<br class="display--sp">ヒール高めのコインローファーがおすすめです',
        productBtnName: 'ヒール高めのコインローファー<br class="display--pc">',
        productBtnLine: '2',
        link: 'https://store.haruta-shoes.co.jp/p/search?keyword=2022HIG04',
        imgPath: './share/images/shindan_modal_result_f3.jpg',
        name: '2022HIG04',
      },
      {
        id: 'result_f4',
        title: 'アンテナが鋭いあなた',
        productName: '限定ローファー',
        productBtnName: '限定ローファー',
        productBtnLine: '1',
        text: '常に一歩先を行っていて、<br class="display--sp">みんなが知らないことをいつも先に察知している<br class="display--sp">あなたなら、もう知っていたかも？<br class="display--sp">今年はインソールが特別なデザインの<br class="display--sp">限定ローファーがおすすめです',
        link: 'https://store.haruta-shoes.co.jp/p/search?keyword=2022HIG08',
        imgPath: './share/images/shindan_modal_result_f4.jpg',
        name: '2022HIG08',
      },
      {
        id: 'result_c1',
        title: '本物志向なあなた',
        productName: '牛革の<br class="display--pc">ローファー',
        text: '本当に大切なことや価値あるものを<br class="display--sp">見分けられるあなたには<br class="display--sp">革の風合いとだんだん自分の足に<br class="display--sp">馴染んでいく過程を楽しめる<br class="display--sp">牛革のコインローファーがおすすめです',
        productBtnName: '牛革のローファー',
        productBtnLine: '1',
        link: 'https://store.haruta-shoes.co.jp/p/search?keyword=2022HIG01',
        imgPath: './share/images/shindan_modal_result_c1.jpg',
        name: '2022HIG01',
      },
      {
        id: 'result_c2',
        title: '心やさしいあなた',
        productName: 'カップインソール<br class="display--pc">ローファー',
        text: '他人にやさしいだけでなく、自分自身もいたわれる。<br class="display--sp">そんなあなたには足に優しい<br class="display--sp">カップインソールローファーがおすすめです',
        productBtnName: 'カップインソールローファー',
        productBtnLine: '1',
        link: 'https://store.haruta-shoes.co.jp/p/search?keyword=2022HIG03',
        imgPath: './share/images/shindan_modal_result_c2.jpg',
        name: '2022HIG03',
      },
      {
        id: 'result_c3',
        title: 'リアリストなあなた',
        productName: '人工皮革の<br class="display--pc">ローファー',
        text: '効率よく、無駄のない選択ができるあなたには<br class="display--sp">価格も手頃で手入れも簡単な<br class="display--sp">人工皮革のコインローファーがおすすめです',
        productBtnName: '人工皮革のローファー',
        productBtnLine: '1',
        link: 'https://store.haruta-shoes.co.jp/p/search?keyword=2022HIG02',
        imgPath: './share/images/shindan_modal_result_c3.jpg',
        name: '2022HIG02',
      },
      {
        id: 'result_c4',
        title: 'アクティブなあなた',
        productName: 'スコッチガード素材の<br>ローファー',
        text: '行動的で怖いもの知らず。<br class="display--sp">思い立ったらすぐ実行にうつすあなたには<br class="display--sp">撥水処理で雨にも強い<br class="display--sp">スコッチガード素材のローファーがおすすめです',
        productBtnName: 'スコッチガード素材のローファー<br>',
        productBtnLine: '2',
        link: 'https://store.haruta-shoes.co.jp/p/search?keyword=2022HIG06',
        imgPath: './share/images/shindan_modal_result_c4.jpg',
        name: '2022HIG06',
      },
    ],
  },
  mutations: {
    reset: function (state) {
      state.userSelect.link = 'b1';
      state.userSelect.linkDefaultFashionId = 'f1';
      state.userSelect.linkDefaultComfortId = 'c1';
      state.userSelect.type.fashion = 0;
      state.userSelect.type.comfort = 0;
      state.userSelect.resultId = '';
    },

    setLink: function (state, nextLinkId) {
      state.userSelect.link = nextLinkId;
    },

    setResult: function (state, resultId) {
      state.userSelect.resultId = resultId;
    },

    setNextQustionNum: function (state) {
      state.userSelect.currentQnum++;
    },

    setTypeCount: function (state, type) {
      state.userSelect.type[type]++;
    },

    setUserAnswer: function (state, obj) {
      state.userSelect.count[obj.cate]++;
      state.userSelect.answer['a' + obj.currentQnum] = obj.answerId;
    },
    // setWid: function (state, array) {
    //   state.filter.wid = array;
    // },
    // setCol: function (state, array) {
    //   state.filter.col = array;
    // },
    // setDes: function (state, array) {
    //   state.filter.des = array;
    // },
    // setHee: function (state, array) {
    //   state.filter.hee = array;
    // },
  },
  actions: {

  },
  modules: {
  }
})
